import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type UploadBlobMutationVariables = {
  parentId: Types.Scalars['ID'],
  parentType: Types.Scalars['String'],
  file: Types.Scalars['Upload']
};


export type UploadBlobMutation = (
  { __typename?: 'Mutation' }
  & { uploadBlob: (
    { __typename?: 'Blob' }
    & Pick<Types.Blob, 'uri' | 'containerUri' | 'name'>
  ) }
);

export const UploadBlobDocument = gql`
    mutation UploadBlob($parentId: ID!, $parentType: String!, $file: Upload!) {
  uploadBlob(parentId: $parentId, parentType: $parentType, file: $file) {
    uri
    containerUri
    name
  }
}
    `;
export type UploadBlobMutationFn = ApolloReactCommon.MutationFunction<UploadBlobMutation, UploadBlobMutationVariables>;

    export function useUploadBlobMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadBlobMutation, UploadBlobMutationVariables>) {
      return ApolloReactHooks.useMutation<UploadBlobMutation, UploadBlobMutationVariables>(UploadBlobDocument, baseOptions);
    };
export type UploadBlobMutationHookResult = ReturnType<typeof useUploadBlobMutation>;
export type UploadBlobMutationResult = ApolloReactCommon.MutationResult<UploadBlobMutation>;
export type UploadBlobMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadBlobMutation, UploadBlobMutationVariables>;